import React, { useState } from 'react';
import { Navbar } from '../layouts/Navbar';
import { Footer } from '../layouts/Footer';

export const Resources = () => {
    const [activeCategory, setActiveCategory] = useState('all');
    
    // Footer header content for resources page
    const footerHeader = ["Learn and Grow", "Access our comprehensive resources"];

    const resources = [
        {
            id: 1,
            title: "Complete Guide to Healthcare Queue Management",
            category: "guides",
            type: "PDF Guide",
            description: "A comprehensive 50-page guide covering best practices for implementing queue management in healthcare settings.",
            downloadUrl: "#",
            featured: true,
            tags: ["Queue Management", "Best Practices", "Implementation"]
        },
        {
            id: 2,
            title: "WhatsApp Business API for Healthcare",
            category: "documentation",
            type: "Documentation",
            description: "Technical documentation for integrating WhatsApp Business API with healthcare systems.",
            downloadUrl: "#",
            featured: false,
            tags: ["WhatsApp", "API", "Integration"]
        },
        {
            id: 3,
            title: "ROI Calculator for Clinic Management Systems",
            category: "tools",
            type: "Calculator",
            description: "Calculate the return on investment for implementing digital queue management in your clinic.",
            downloadUrl: "#",
            featured: true,
            tags: ["ROI", "Calculator", "Financial"]
        },
        {
            id: 4,
            title: "Patient Experience Improvement Strategies",
            category: "guides",
            type: "Whitepaper",
            description: "Research-backed strategies to improve patient satisfaction and reduce complaints.",
            downloadUrl: "#",
            featured: false,
            tags: ["Patient Experience", "Research", "Satisfaction"]
        },
        {
            id: 5,
            title: "Clinqo API Documentation",
            category: "documentation",
            type: "API Docs",
            description: "Complete API reference for developers integrating with Clinqo platform.",
            downloadUrl: "#",
            featured: false,
            tags: ["API", "Development", "Integration"]
        },
        {
            id: 6,
            title: "Healthcare Digital Transformation Trends 2025",
            category: "research",
            type: "Research Report",
            description: "Annual report on digital transformation trends in Indian healthcare sector.",
            downloadUrl: "#",
            featured: true,
            tags: ["Digital Transformation", "Trends", "Healthcare"]
        },
        {
            id: 7,
            title: "Clinic Setup Checklist",
            category: "tools",
            type: "Checklist",
            description: "Complete checklist for setting up Clinqo in your healthcare facility.",
            downloadUrl: "#",
            featured: false,
            tags: ["Setup", "Checklist", "Implementation"]
        },
        {
            id: 8,
            title: "HIPAA Compliance in Digital Healthcare",
            category: "compliance",
            type: "Compliance Guide",
            description: "Understanding data privacy and compliance requirements in healthcare technology.",
            downloadUrl: "#",
            featured: false,
            tags: ["HIPAA", "Compliance", "Privacy"]
        }
    ];

    const categories = [
        { id: 'all', name: 'All Resources', count: resources.length },
        { id: 'guides', name: 'Guides & Whitepapers', count: resources.filter(r => r.category === 'guides').length },
        { id: 'documentation', name: 'Documentation', count: resources.filter(r => r.category === 'documentation').length },
        { id: 'tools', name: 'Tools & Calculators', count: resources.filter(r => r.category === 'tools').length },
        { id: 'research', name: 'Research Reports', count: resources.filter(r => r.category === 'research').length },
        { id: 'compliance', name: 'Compliance', count: resources.filter(r => r.category === 'compliance').length }
    ];

    const filteredResources = activeCategory === 'all' 
        ? resources 
        : resources.filter(resource => resource.category === activeCategory);

    const featuredResources = resources.filter(resource => resource.featured);

    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />
            
            {/* Hero Section */}
            <div className="bg-gradient-to-r from-green-600 to-blue-600 text-white py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <br />
                        <h1 className="text-4xl md:text-5xl font-bold mb-6">Resource Center</h1>
                        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
                            Access guides, documentation, tools, and research to help you succeed with healthcare technology.
                        </p>
                        <div className="relative max-w-md mx-auto">
                            <input
                                type="text"
                                placeholder="Search resources..."
                                className="w-full px-4 py-3 pl-12 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
                            />
                            <svg className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            {/* Featured Resources */}
            <div className="py-16 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">Featured Resources</h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            Our most popular and comprehensive resources to get you started.
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {featuredResources.slice(0, 3).map((resource) => (
                            <div key={resource.id} className="bg-gradient-to-br from-blue-50 to-green-50 rounded-lg p-6 border border-blue-200 hover:shadow-lg transition duration-300">
                                <div className="flex items-center justify-between mb-4">
                                    <span className="bg-blue-600 text-white text-sm px-3 py-1 rounded-full font-medium">
                                        {resource.type}
                                    </span>
                                    <span className="bg-yellow-400 text-yellow-900 text-xs px-2 py-1 rounded-full font-bold">
                                        FEATURED
                                    </span>
                                </div>
                                <h3 className="text-xl font-bold text-gray-900 mb-3">{resource.title}</h3>
                                <p className="text-gray-600 mb-4">{resource.description}</p>
                                <div className="flex flex-wrap gap-2 mb-4">
                                    {resource.tags.map((tag, index) => (
                                        <span key={index} className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded">
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                                <button className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300">
                                    Coming Soon
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* All Resources */}
            <div className="py-16 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">All Resources</h2>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            Browse our complete library of resources organized by category.
                        </p>
                    </div>

                    {/* Category Filter */}
                    <div className="flex flex-wrap justify-center gap-4 mb-12">
                        {categories.map((category) => (
                            <button
                                key={category.id}
                                onClick={() => setActiveCategory(category.id)}
                                className={`px-6 py-3 rounded-lg font-medium transition duration-300 ${
                                    activeCategory === category.id
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-white text-gray-700 hover:bg-gray-100'
                                }`}
                            >
                                {category.name} ({category.count})
                            </button>
                        ))}
                    </div>

                    {/* Resource Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filteredResources.map((resource) => (
                            <div key={resource.id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300">
                                <div className="flex items-center justify-between mb-4">
                                    <span className="bg-gray-100 text-gray-800 text-sm px-3 py-1 rounded-full font-medium">
                                        {resource.type}
                                    </span>
                                    {resource.featured && (
                                        <span className="bg-yellow-400 text-yellow-900 text-xs px-2 py-1 rounded-full font-bold">
                                            FEATURED
                                        </span>
                                    )}
                                </div>
                                <h3 className="text-lg font-bold text-gray-900 mb-3">{resource.title}</h3>
                                <p className="text-gray-600 mb-4 text-sm">{resource.description}</p>
                                <div className="flex flex-wrap gap-2 mb-4">
                                    {resource.tags.slice(0, 2).map((tag, index) => (
                                        <span key={index} className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded">
                                            {tag}
                                        </span>
                                    ))}
                                    {resource.tags.length > 2 && (
                                        <span className="text-gray-500 text-xs">+{resource.tags.length - 2} more</span>
                                    )}
                                </div>
                                <button className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300">
                                    Coming Soon
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Newsletter Signup */}
            <div className="bg-blue-600 text-white py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-3xl font-bold mb-4">Stay Updated</h2>
                    <p className="text-xl mb-8 max-w-2xl mx-auto">
                        Get notified when we publish new resources, guides, and research reports.
                    </p>
                    <div className="max-w-md mx-auto flex gap-4">
                        <input
                            type="email"
                            placeholder="Enter your email"
                            className="flex-1 px-4 py-3 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
                        />
                        <button className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300">
                            Subscribe
                        </button>
                    </div>
                </div>
            </div>

            <Footer header={footerHeader} />
        </div>
    );
};
